import React from 'react';
import { useTranslation } from 'react-i18next';

export type WithTranslation = {
    translation?: string;
    translationOptions?: Record<string, unknown>;
};

export const TranslationOrChildren: React.FC<
    React.PropsWithChildren<WithTranslation>
> = ({ translation, translationOptions = {}, children }) => {
    const { t } = useTranslation();
    return translation ? (
        <>{t(translation, translationOptions)}</>
    ) : (
        <>{children}</>
    );
};
